import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import certificate from "../../assets/img/Certificate_of_Registration.jpg";
import AboutModal from "./AboutModal";


const api_url = process.env.REACT_APP_API_URL;

const About = () => {

    const [ManagementMembers, setManagementMembers] = useState([]);

    // Fetch slider data from the API
    useEffect(() => {
        const fetchManagementMembers = async () => {
            try {
                const response = await axios.get(`${api_url}/management_members_sliders.php`);
                setManagementMembers(response.data);  // Save the fetched data in state
            } catch (error) {
                console.error("Error fetching sliders:", error);
            }
        };

        fetchManagementMembers();
    }, []);

    return (
        <>
            {/* <!-- Header Start --> */}
            <div className="container-fluid bg-primary py-5 mb-5 page-header">
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <h1 className="display-3 text-white animated slideInDown">About Us</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center">
                                    <li className="breadcrumb-item"><Link className="text-white" to="#">Home</Link></li>
                                    <li className="breadcrumb-item"><Link className="text-white" to="#">Pages</Link></li>
                                    <li className="breadcrumb-item text-white active" aria-current="page">About</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Header End --> */}



            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-4 justify-content-center">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                                    <h3 className="section-title bg-white text-start text-primary pe-3">About Us</h3>
                                </div>
                                <br /> <br />
                                <p><strong>Name of Society:</strong> ALUMNI ASSOCIATION OF KENDRIYA VIDYALAYA ORDNANCE FACTORY BHANDARA</p>
                                <p><strong>Registered Office:</strong>H. NO- 44, KH. NO- 1791/2,  FIRST FLOOR, LAL DORA, BLK-WZ, VILLAGE NARAINA, NEW DELHI- 1100028.</p>
                                <p><strong>Work Area:</strong> The area of operation of society shall be at National Level.</p>
                                <button type="button" className="btn btn-primary py-1 px-3 mt-2 btn-flat" data-bs-toggle="modal" data-bs-target="#aboutModal" > Read more </button>
                            </div>

                            <div className="col-md-6">
                                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                                    <h3 className="section-title bg-white text-center text-primary px-3">Certificate</h3>
                                </div>
                                <img src={certificate} alt="Certificate_of_Registration" className="img-fluid" />
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            {/* <!-- Team Start --> */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                        <h1 className="section-title bg-white text-center text-primary px-3">Office Bearers</h1>
                    </div>

                    {ManagementMembers.length > 0 && (
                        <div className="row g-4">
                            {ManagementMembers.map((mm) => (
                                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                                    <div className="team-item bg-light">
                                        <div className="overflow-hidden">
                                            <center> <img className="img-fluid" src={mm.profile_img} alt={mm.fullname} style={{ height: '200px', paddingTop: '20px' }} /></center>
                                        </div>
                                        <div className="position-relative d-flex justify-content-center" style={{ marginTop: '-23px' }}>
                                            {/* <div className="bg-light d-flex justify-content-center pt-2 px-1">
                                            <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-facebook-f"></i></a>
                                            <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-twitter"></i></a>
                                            <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-instagram"></i></a>
                                            </div> */}
                                        </div>
                                        <div className="text-center p-4" >
                                            <h5 className="mb-0"> {mm.fullname}</h5>
                                            <small>{mm.designation}</small>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    )}
                </div>
            </div>
            {/* <!-- Team End --> */}
            <AboutModal />

        </>

    );
};

export default About;
